<template>
    <div
        v-if="shoppingCartInit"
        class="lo router"
    >
        <loPage
            v-if="shoppingCart.length"
        >
            <loSection>
                <loArticle>
                    <pgCartList
                        v-for="(item, key) in computedShoppingCart"
                        :key="key"
                        :type="key"
                        :list="item"
                        @sendEvent="receiveEvent"
                    ></pgCartList>
                </loArticle>
            </loSection>
        </loPage>
        <loPage
            v-else
        >
            <mdCartNull
                class="is-cartList"
            ></mdCartNull>
        </loPage>
    </div>
    <div
        v-else
        class="lo router"
    >
        <loPage>
            <div class="g mask-box">
                <mdLoading></mdLoading>
            </div>
        </loPage>
    </div>
</template>

<script>
    import loPage from '@/components/loPage'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import pgCartList from '@/components/pgCartList'
    import mdCartNull from '@/components/mdCartNull'
    import mdLoading from '@/components/mdLoading'

    import { mapState, mapMutations } from 'vuex'

    let $_getDefaultShoppingCart = () => {

            return {
                hasprice: [],
                noprice: [],
                unmarket: [],
            }
        }

    export default {
        components: {
            loPage,
            loSection,
            loArticle,
            pgCartList,
            mdCartNull,
            mdLoading,
        },
        data: function(){
           
            return {
                computedShoppingCart: $_getDefaultShoppingCart(),
            }
        },
        computed: {
            ...mapState([
                'shoppingCart',
                'shoppingCartInit',
                'priceObject',
            ]),
        },
        watch: {
            shoppingCart: {
                handler: function(){
                    this.initShoppingCart();
                }
            },
        },
        methods: {
            ...mapMutations([
                'initCredit',
            ]),
            sendOrderDone: function(type){
                let _type = type;

                if( type ) {
                    _type = 2;
                }

                if( this.shoppingCart.length === 0 ) {
                    this.$router.push('/system/account?page=purchase&tab='+ _type);
                }
            },
            priceForGoods: function(){
                let $shoppingCartList = this.computedShoppingCart.hasprice,
                    $value = 0,
                    $items = [];

                $shoppingCartList.forEach(item => {
                    let _customer_need_date = item.customer_need_date,
                        $date = new Date();

                    if( _customer_need_date ) {
                        $date = new Date(_customer_need_date);
                    }

                    let _date = $date.toLocaleDateString(),
                        _price = this.$siteTool.computedPrice(item, _date);
                    
                    item.price = _price;
                    $value += item.qty * item.price;
                    $items.push({
                        item_id: item.cart_sn,
                        item_name: item.product_s,
                        item_brand: "Formosa Plastic Corporation",
                        item_category: item.product_b,
                        item_category2: item.product_m,
                        item_category3: item.product_s,
                        price: item.price,
                        quantity: item.qty
                    })
                })

                return {
                    value: $value,
                    items: $items
                }
            },
            beginCheckout:function(){
                let goods = this.priceForGoods();

                if( goods.value > 0 ){
                    //只有商品有價格 才會推送begin_checkout事件
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        event: "begin_checkout",
                        ecommerce: {
                            currency: "TWD",
                            value: goods.value,
                            items: goods.items
                        }
                    });
                }
            },
            initShoppingCart: function(){
                let $shoppingCart = this.shoppingCart,
                    $result = $_getDefaultShoppingCart();

                $shoppingCart.forEach(item => {

                    if( item.is_on_market ) {
                        let $product = this.$siteTool.getProduct(item);

                        if( $product ) {
                            let _price = this.$siteTool.getPrice($product, item.customer_need_date);

                            if( typeof _price === 'number' ) {
                                $result.hasprice.push(item);
                            }else {
                                $result.noprice.push(item);
                            }
                        }
                    }else {
                        $result.unmarket.push(item);
                    }
                });
                
                this.$set(this, 'computedShoppingCart', $result);
            },
        },
        created: async function(){
            this.initCredit();
            this.initShoppingCart();
            this.beginCheckout();
        }
    }
</script>

<style scoped lang="scss">

    .lo.router {
        max-width: 1200px;
        margin: 0 auto;

        &::v-deep {

            .lo.page {
                flex-direction: column;
            }

            .g.mask-box {

                .md.loading {
                    height: calc(100vh - 80px);
                }
            }
        }
    }
</style>
